import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import styles from './ui-exit-icon.css?inline';
import '../ui-inlined-svg/ui-inlined-svg';

@customElement('ui-exit-icon')
export class UIExitIcon extends LitElement {
  static readonly styles = unsafeCSS(styles);

  render() {
    // Use vite to transform static URL
    const assetUrl = new URL('/assets/ui-core/icons/navigation/logout-icon.svg', import.meta.url).href;
    return html`<ui-inlined-svg .css=${UIExitIcon.styles} .defer=${true} .src=${assetUrl}></ui-inlined-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ui-exit-icon': UIExitIcon;
  }
}
